// Custom artist routes load their existing biography asynchronously.
// Synchronize metadata from that rendered content without changing the page.
(() => {
  const root = document.querySelector('[data-artist-page]:not([data-artist-index])');
  if (!root) return;
  let complete = false;
  const update = () => {
    const heading = root.querySelector('[data-artist-title]');
    const biography = root.querySelector('.art-artist-description');
    if (complete || !heading || !biography) return;
    const name = heading.textContent.trim();
    if (!name) return;
    complete = true;
    const url = new URL(location.pathname, location.origin);
    const query = new URLSearchParams(location.search);
    if (root.dataset.handle === 'contact') {
      const view = query.get('view');
      if (view === 'artist' || view === 'memory') url.searchParams.set('view', view);
      const artist = query.get('artist') || root.dataset.preview;
      if (artist) url.searchParams.set('artist', artist);
    }
    const title = `${name} | Artist Biography and Artworks | Art and Twist`;
    const summary = `Explore ${name}’s biography and artworks in the Art and Twist artist gallery.`;
    document.title = title;
    const set = (selector, attribute, content) => {
      let node = document.head.querySelector(selector);
      if (!node) return;
      node.setAttribute(attribute, content);
    };
    set('link[rel="canonical"]', 'href', url.href);
    set('meta[name="description"]', 'content', summary);
    for (const key of ['og:title', 'twitter:title']) set(`meta[${key.startsWith('og:') ? 'property' : 'name'}="${key}"]`, 'content', title);
    for (const key of ['og:description', 'twitter:description']) set(`meta[${key.startsWith('og:') ? 'property' : 'name'}="${key}"]`, 'content', summary);
    set('meta[property="og:url"]', 'content', url.href);
    const image = root.querySelector('.art-artist-grid img');
    if (image) {
      set('meta[property="og:image"]', 'content', image.src);
      set('meta[property="og:image:secure_url"]', 'content', image.src);
      set('meta[name="twitter:image"]', 'content', image.src);
    }
    const schema = document.getElementById('art-page-schema');
    if (schema) {
      const data = JSON.parse(schema.textContent);
      const page = data['@graph'][0];
      Object.assign(page, { '@id': `${url.href}#webpage`, url: url.href, name: title, description: summary, about: { '@type': 'Person', name } });
      if (image) page.primaryImageOfPage = { '@type': 'ImageObject', url: image.src };
      if (data['@graph'][1]?.['@type'] === 'BreadcrumbList') Object.assign(data['@graph'][1].itemListElement[1], { name, item: url.href });
      schema.textContent = JSON.stringify(data);
    }
    observer.disconnect();
  };
  const observer = new MutationObserver(update);
  observer.observe(root, { childList: true, subtree: true });
  update();
})();
